import { IConfig } from '@studyportals/search-filters';
import { injectable } from 'inversify';

@injectable()
export class FilterConfig implements IConfig {
	public readonly autocompleteApiUrl: string;

	public constructor() {
		this.autocompleteApiUrl = CONFIG.AUTOCOMPLETE_API_URL;
	}
}
